import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationApi>;
}

const WoltDriveBasicForm = ({ form }: Props) => {
	const {
		formState: { errors },
		register,
	} = form;
	const { t } = useTranslation();

	return (
		<fieldset className="form-group">
			<FormInput
				name="settings.venue_id"
				errors={errors}
				register={register}
				label={t("modules.app.field.venue_id.title")}
				disabled
			/>
			<FormInput
				name="settings.merchant_id"
				errors={errors}
				register={register}
				label={t("modules.app.field.merchant_id.title")}
				disabled
			/>
			<FormInput
				name="settings.api_key"
				errors={errors}
				register={register}
				label={t("modules.app.field.api_key.title")}
				disabled
			/>
			<FormInput
				name="settings.support_url"
				errors={errors}
				register={register}
				label={t("modules.app.field.support_url.title")}
			/>
			<FormInput
				name="settings.support_email"
				errors={errors}
				register={register}
				label={t("modules.app.field.support_email.title")}
			/>
			<FormInput
				name="settings.support_phone_number"
				errors={errors}
				register={register}
				label={t("modules.app.field.support_phone_number.title")}
			/>
		</fieldset>
	);
};

export default WoltDriveBasicForm;
